import type {
  ExecuteCommandInput,
  ExecuteCommandResult,
  FocusBucket,
  PortfolioView,
  TodayQueueResponse,
  CommandAuditEntry,
  CommandEvent,
} from "@ceo-cmd/shared";
import { apiGet, apiPost } from "./client";

export async function getTodayQueue(opts: {
  bucket?: FocusBucket;
  view?: PortfolioView;
  companyId?: string;
} = {}): Promise<TodayQueueResponse> {
  const params: Record<string, string> = {};
  if (opts.bucket) params.bucket = opts.bucket;
  if (opts.view) params.view = opts.view;
  if (opts.companyId) params.companyId = opts.companyId;
  return apiGet("/api/today", params);
}

export async function getTodayItemAudit(
  itemId: string,
): Promise<{ audit: CommandAuditEntry[] }> {
  return apiGet(`/api/today/items/${itemId}/audit`);
}

export async function getTodayItemEvents(
  itemId: string,
): Promise<{ events: CommandEvent[] }> {
  return apiGet(`/api/today/items/${itemId}/events`);
}

export async function listTodayDecisions(
  limit = 50,
): Promise<{ decisions: import("@ceo-cmd/shared").DecisionTrailEntry[] }> {
  return apiGet("/api/today/decisions", { limit: String(limit) });
}

export async function executeTodayItem(
  itemId: string,
  body: ExecuteCommandInput = {},
): Promise<{ outcome: ExecuteCommandResult; queue: TodayQueueResponse }> {
  return apiPost(`/api/today/items/${itemId}/execute`, body);
}

export async function retryTodayItemEffects(
  itemId: string,
  dispositionEventId: string,
): Promise<{ outcome: ExecuteCommandResult; queue: TodayQueueResponse }> {
  return apiPost(`/api/today/items/${itemId}/effects/retry`, {
    dispositionEventId,
  });
}

export async function undoTodayItem(
  itemId: string,
): Promise<{ outcome: ExecuteCommandResult; queue: TodayQueueResponse }> {
  return apiPost(`/api/today/items/${itemId}/undo`, {});
}
